import AdminDashboard from '../../../api/adminDashboard/adminDashboard';
import fileDownload from "js-file-download";
import router from "@/router";

const adminDashboard = new AdminDashboard();

const adminDashboardModule = {
  namespaced: true,
  state: {
    schools: [],
    ApiTracker: [],
    loadSchools:false,
    LoadApiTracker:false,
  },
  getters: {
    schools(state) {
      return state.schools;
    },
    ApiTracker(state) {
      return state.ApiTracker;
    },
    loadSchools(state) {
      return state.loadSchools;
    },
    LoadApiTracker(state) {
      return state.LoadApiTracker;
    },
    
  },
  mutations: {
    SET_SCHOOLS: (state, schools) => {
      state.schools = schools;
    },
    SET_APITRACKER: (state, ApiTracker) => {
      state.ApiTracker = ApiTracker;
    },
    SET_LOAD_SCHOOLS: (state, loadSchools) => {
      state.loadSchools = loadSchools;
    },
    SET_LOAD_APITRACKER: (state, LoadApiTracker) => {
      state.LoadApiTracker = LoadApiTracker;
    },
  },
  actions: {
    topSchools({ commit }) {
      return new Promise((resolve, reject) => {
        commit('SET_LOAD_SCHOOLS', true);
        adminDashboard.topSchools().then(response => {
          commit('SET_SCHOOLS', response.schools);
          commit('SET_LOAD_SCHOOLS', false);
          resolve();
        }).catch(error => {
          reject(error);
          commit('SET_LOAD_SCHOOLS', false);
        });
      });
    },
    api_tracker({ commit }, payload) {
      return new Promise((resolve, reject) => {
        commit('SET_LOAD_APITRACKER', true);
        console.log("payload", payload);
        
        adminDashboard.api_tracker(payload).then(response => {
          commit('SET_APITRACKER', response);
          commit('SET_LOAD_APITRACKER', false);
          resolve();
        }).catch(error => {
          reject(error);
          commit('SET_LOAD_APITRACKER', false);
        });
      });
    },
  },
};

export default adminDashboardModule;
